module.exports = __webpack_public_path__ + "ai-sparkle.svg?406d7425198fb0b1c1893b7fbb8490b6";